<div class="row">
  <div
    class="col-1 p-l-0 logoColumn"
    [class.headerColor]="backGround"
    [class.p-10]="!backGround"
  >
    <a
      href="{{ homeAdd }}"
      target="{{ target }}"
      style="padding-top: 100px"
      *ngIf="homeClick; else regImage"
    >
      <!-- src="assets/img/logo/i3rsr75.png" -->
      <img
        src="assets/img/logo/saferec.png"
        alt="logo saferec"
        width="100"
        height="100"
        [class.headerColor]="backGround"
      />
    </a>
    <ng-template #regImage>
      <!-- src="assets/img/logo/i3rsr75.png" -->
      <img
        src="assets/img/logo/saferec.png"
        alt="saferec"
        width="100"
        height="100"
        [class.headerColor]="backGround"
      />
    </ng-template>
  </div>
  <div
    class="col-11 titlesContainer"
    style="padding-left: 60px; padding-right: 0px"
    [class.headerColor]="backGround"
  >
    <h4 class="antiTitleRed d-block">{{ "PageTitle1" | translate }}</h4>
    <h5 class="antiTitle d-block mb-2" style="font-size: 13px">
      {{ "PageTitle2" | translate }}
    </h5>

    <table>
      <tbody>
        <tr>
          <td>
            <h5 class="title-phone antiTitle d-block">
              {{ "PageTitle3a" | translate }}
            </h5>
          </td>
          <td>
            <h5 class="title-phone antiTitle d-block">
              {{ "PageTitle3b" | translate }}
            </h5>
          </td>
        </tr>
      </tbody>
    </table>

    <h4 class="antiTitleRed d-block">{{ "PageTitle5" | translate }}</h4>
  </div>
</div>
